export default __webpack_public_path__ + "static/media/tunica-blanca-hombre.f2fca919.png";